"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHLQATasksBulkActions = void 0;
const react_1 = require("react");
const priority_task_1 = require("../../../client/priority-task");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const useHLQATasksBulkActions = ({ catalogId, productTreeId, apiFilter, totalCount, areAllItemsSelected, getSelectedTaskNodes, resetSelection, refetch, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { bulkUpdatePriorityTasks, loading: isBulkUpdateLoading } = (0, priority_task_1.useBulkUpdatePriorityTasks)();
    const { addError, addSuccess } = (0, hooks_1.useNotification)();
    const [isBulkEditModalOpen, setIsBulkEditModalOpen] = (0, react_1.useState)(false);
    const getFailureMessageSuffix = (0, react_1.useCallback)((failedCount) => {
        if (failedCount <= 0) {
            return '';
        }
        return ` ${t({ key: 'HLQA_TASKS_FAILED_TO_UPDATE_MESSAGE', values: { count: failedCount } })}`;
    }, [t]);
    const handleBulkEditMutationResult = (0, react_1.useCallback)((updatedCount, attemptedCount) => {
        const failedCount = Math.max(attemptedCount - updatedCount, 0);
        const successMessage = t({
            key: 'HLQA_BULK_EDIT_SUCCESS_MESSAGE',
            values: {
                count: updatedCount,
            },
        });
        addSuccess(`${successMessage}${getFailureMessageSuffix(failedCount)}`);
        return failedCount;
    }, [addSuccess, getFailureMessageSuffix, t]);
    const buildBulkEditMutationInput = (0, react_1.useCallback)((baseInput, selectedTaskNodes) => {
        const isSelectAllMode = areAllItemsSelected;
        return Object.assign(Object.assign({}, baseInput), (isSelectAllMode
            ? {
                filter: apiFilter,
                expectedMatchedTaskCount: totalCount !== null && totalCount !== void 0 ? totalCount : 0,
            }
            : {
                productTreeNodeIds: selectedTaskNodes,
            }));
    }, [apiFilter, areAllItemsSelected, totalCount]);
    const handleOpenBulkEditModal = (0, react_1.useCallback)(() => {
        setIsBulkEditModalOpen(true);
    }, []);
    const handleCloseBulkEditModal = (0, react_1.useCallback)(() => {
        setIsBulkEditModalOpen(false);
    }, []);
    const handleSaveBulkEditModal = (0, react_1.useCallback)((values) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!catalogId || !productTreeId) {
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            return;
        }
        const hasAnyChanges = Object.values(values).some((value) => value !== undefined);
        if (!hasAnyChanges) {
            setIsBulkEditModalOpen(false);
            return;
        }
        const baseInput = Object.assign(Object.assign(Object.assign({ catalog: catalogId, productTreeId, clientMutationId: '' }, (values.priority !== undefined ? { priority: values.priority } : {})), (values.status !== undefined ? { status: values.status } : {})), (values.assignedTo !== undefined ? { assignedTo: values.assignedTo } : {}));
        const isSelectAllMode = areAllItemsSelected;
        const selectedTaskNodes = isSelectAllMode ? [] : getSelectedTaskNodes();
        if (!isSelectAllMode && selectedTaskNodes.length === 0) {
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            return;
        }
        const attemptedCount = isSelectAllMode
            ? (totalCount !== null && totalCount !== void 0 ? totalCount : 0)
            : selectedTaskNodes.length;
        const mutationInput = buildBulkEditMutationInput(baseInput, selectedTaskNodes);
        try {
            const result = yield bulkUpdatePriorityTasks(mutationInput);
            const updatedCount = (_a = result === null || result === void 0 ? void 0 : result.updatedCount) !== null && _a !== void 0 ? _a : attemptedCount;
            const failedCount = handleBulkEditMutationResult(updatedCount, attemptedCount);
            yield refetch();
            setIsBulkEditModalOpen(false);
            if (failedCount === 0) {
                resetSelection();
            }
        }
        catch (_b) {
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
    }), [
        addError,
        areAllItemsSelected,
        buildBulkEditMutationInput,
        bulkUpdatePriorityTasks,
        catalogId,
        getSelectedTaskNodes,
        handleBulkEditMutationResult,
        productTreeId,
        refetch,
        resetSelection,
        t,
        totalCount,
    ]);
    return {
        isBulkUpdateLoading,
        isBulkEditModalOpen,
        handleOpenBulkEditModal,
        handleCloseBulkEditModal,
        handleSaveBulkEditModal,
    };
};
exports.useHLQATasksBulkActions = useHLQATasksBulkActions;
